import { useEffect, useState } from "react";

// Reports whether `containerRef`'s content overflows its own width, at any
// screen width — a fixed breakpoint hides overflow controls past very wide
// viewports even when more items than that viewport can fit still overflow.
const useElementOverflow = (containerRef, contentRef) => {
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const container = containerRef?.current;
    const content = contentRef?.current;
    if (!container || !content) return;

    const checkOverflow = () => {
      setIsOverflowing(container.scrollWidth > container.clientWidth + 1);
    };

    checkOverflow();

    const resizeObserver = new ResizeObserver(checkOverflow);
    resizeObserver.observe(container);
    resizeObserver.observe(content);
    window.addEventListener("resize", checkOverflow);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", checkOverflow);
    };
  }, [containerRef, contentRef]);

  return isOverflowing;
};

export default useElementOverflow;
